import { debounce } from "lodash";
import { SetStateAction } from "react";

export const handleDebouncedSearch = debounce((setState: SetStateAction<any>) => {
  setState();
}, 1000);
